import type { CustomerV2Status } from 'types/customers'
import {
  AddBusinessCustomerV2ComboboxKey,
  AddBusinessCustomerV2FormData,
  AddBusinessCustomerV2FormKey,
  AddBusinessCustomerV2SingleDateKey,
} from './types'

export const BUSINESS_USE_CASES: Record<string, string> = {
  stablecoinPayouts: 'STABLECOIN_PAYOUTS',
  embeddedStablecoinWallets: 'EMBEDDED_STABLECOIN_WALLETS',
  embeddedFiatAccounts: 'EMBEDDED_FIAT_ACCOUNTS',
}

export const MONTHLY_EXPECTED_VOLUMES: Record<string, string> = {
  under100k: 'UNDER_100K',
  from100kTo1m: 'FROM_100K_TO_1M',
  from1mTo10m: 'FROM_1M_TO_10M',
  from10mTo100m: 'FROM_10M_TO_100M',
  over100m: 'OVER_100M',
}

export const BUSINESS_SOURCE_OF_FUNDS: Record<string, string> = {
  commercialActivities: 'COMMERCIAL_ACTIVITIES',
  shareholderCapital: 'SHAREHOLDER_CAPITAL',
  ventureCapital: 'VENTURE_CAPITAL',
  saleOfAssets: 'SALE_OF_ASSETS',
  cryptoFundraising: 'CRYPTO_FUNDRAISING',
  cryptoTradingRevenue: 'CRYPTO_TRADING_REVENUE',
  corporateLoans: 'CORPORATE_LOANS',
  other: 'OTHER',
}

export const BUSINESS_INTENDED_USE_OF_ACCOUNT: Record<string, string> = {
  supplierVendorPayments: 'SUPPLIER_VENDOR_PAYMENTS',
  intercompanyTransfers: 'INTERCOMPANY_TRANSFERS',
  payroll: 'PAYROLL',
  customerPaymentsReceived: 'CUSTOMER_PAYMENTS_RECEIVED',
  customerPayoutsRefundsSettlements: 'CUSTOMER_PAYOUTS_REFUNDS_SETTLEMENTS',
  operatingExpenses: 'OPERATING_EXPENSES',
  dividendProfitDistributions: 'DIVIDEND_PROFIT_DISTRIBUTIONS',
  loanRepaymentFinancialActivities: 'LOAN_REPAYMENT_FINANCIAL_ACTIVITIES',
}
export const COMBOBOX_KEYS: AddBusinessCustomerV2ComboboxKey[] = [
  'useCase',
  'entityType',
  'taxResidenceCountryCode',
  'monthlyExpectedVolumes',
  'sourceOfFunds',
  'intendedUseOfAccount',
  'registeredAddressCountryCode',
  'operationalAddressCountryCode',
]

export const RADIO_KEYS: AddBusinessCustomerV2FormKey[] = [
  'isRegulated',
  'isOperationalAddressDifferent',
]

export const SINGLE_DATE_KEYS: AddBusinessCustomerV2SingleDateKey[] = ['incorporationDate']

export const ADD_BUSINESS_CUSTOMER_V2_DEFAULT_VALUES: AddBusinessCustomerV2FormData = {
  useCase: '',
  name: '',
  entityType: '',
  registrationNumber: '',
  taxNumber: '',
  taxResidenceCountryCode: '',
  naicsCode: '',
  monthlyExpectedVolumes: '',
  isRegulated: '',
  sourceOfFunds: '',
  intendedUseOfAccount: '',
  website: '',
  regulatorName: '',
  regulatorJurisdiction: '',
  incorporationDate: '',
  registeredAddressLine1: '',
  registeredAddressCity: '',
  registeredAddressPostalCode: '',
  registeredAddressCountryCode: '',
  isOperationalAddressDifferent: '',
  operationalAddressLine1: '',
  operationalAddressCity: '',
  operationalAddressPostalCode: '',
  operationalAddressCountryCode: '',
}

export const ASSOCIATE_TYPE_TRANSLATION_KEYS: Record<string, string> = {
  ACCOUNT_REPRESENTATIVE: 'embeddedCustomers.associateTypes.ACCOUNT_REPRESENTATIVE',
  CONTROL_PERSON: 'embeddedCustomers.associateTypes.CONTROL_PERSON',
  DIRECTOR: 'embeddedCustomers.associateTypes.DIRECTOR',
  SIGNATORY: 'embeddedCustomers.associateTypes.SIGNATORY',
  UBO: 'embeddedCustomers.associateTypes.UBO',
  BUSINESS_OWNER: 'embeddedCustomers.associateTypes.BUSINESS_OWNER',
}

export const CUSTOMER_STATUS_AGREEMENTS_PENDING: CustomerV2Status = 'AGREEMENTS_PENDING'
export const CUSTOMER_STATUS_VERIFIED: CustomerV2Status = 'VERIFIED'

export const REQUIRED_ACTION_CATEGORY_ASSOCIATES = 'ASSOCIATES'
export const REQUIRED_ACTION_CATEGORY_DOCUMENT_REQUIREMENTS = 'DOCUMENT_REQUIREMENTS'
export const REQUIRED_ACTION_CATEGORY_COMPANY_INFORMATION = 'COMPANY_INFORMATION'
export const REQUIRED_ACTION_CATEGORY_NATURE_OF_BUSINESS = 'NATURE_OF_BUSINESS'
export const REQUIRED_ACTION_CODE_ALL_ASSOCIATES_VALID = 'REQUIRED_ALL_ASSOCIATES_VALID'
export const REQUIRED_ACTION_CODE_ASSOCIATE_INFO_REQUIRED = 'ASSOCIATE_INFO_REQUIRED'
export const REQUIRED_ACTION_CODE_DOCUMENT_REQUIRED = 'DOCUMENT_REQUIRED'
export const REQUIRED_ACTION_CODE_QUESTIONNAIRE_REQUIRED = 'QUESTIONNAIRE_REQUIRED'

export const DOCUMENT_TYPES = [
  'articleOfAssociation',
  'certificateOfIncorporation',
  'proofOfDirectorship',
  'memorandum',
  'corporateStructure',
  'proofOfOperationalAddress',
  'identity',
  'selfie',
] as const
